<template>
  <!-- side menu -->
  <el-scrollbar class="menu-scroll-container">
    <el-menu
        class="menu-container"
        :default-active="activeMenuPath"
        :default-openeds="openedSubMenus"
        :text-color="skin.sidebarTextColor"
        :active-text-color="skin.sidebarActiveColor"
        :background-color="skin.sidebarBackgroundColor"
        :collapse="sidebar.collapsed"
        @select="handleSelect">
      <template v-for="(item, index) in sidebarMenuRoutes">
        <sidebar-item :item="item" v-bind:key="item.path" :index="index.toString()"/>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import {mapGetters} from 'vuex'
import SidebarItem from './sidebarItem'

export default {
  components: {SidebarItem},
  data() {
    return {
      activeMenuPathVal: null,
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),

    /**
     * 菜单数据容器（用于显示菜单）
     */
    sidebarMenuRoutes() {
      return this.$store.getters.sidebarMenuRoutes;
    },
    /**
     * 菜单数据副本容器（用于关联查找数据，包含全量路由配置）
     */
    sidebarMenuCopyRoutes() {
      return this.$store.getters.menuCopyRoutes;
    },


    /**
     * 活动菜单，和topNav一样
     * @returns {string|default.computed.activeMenuPath}
     */
    activeMenuPath: {
      set(val) {
        this.activeMenuPathVal = val
      },
      get() {
        return this.activeMenuPathVal
      }
    },
    openedSubMenus() {
      let subMenuArr = this.$store.getters.menuRoutes.map(item => item.path);
      // return subMenuArr;
      return [];
    },
    skin() {
      return this.$store.state.app.skin;
    },
  },
  created() {
    this.updateMenuByRoute()
  },
  watch: {
    $route() {
      this.updateMenuByRoute()
    }
  },
  methods: {
    /**
     * 根据路由反向设置active的菜单
     */
    updateMenuByRoute() {
      // 选择菜单（不是页面）
      this.activeMenuPath = this.findParentPath()
    },
    /**
     * 活动菜单，和topNav一样
     * 通过当前路由（页面）找到父path（菜单）
     */
    findParentPath() {
      let path = this.$route.path;
      let item = this.sidebarMenuCopyRoutes[path];
      console.log("----findMenuPath---->", path, item)
      // 如果是iframe，则直接是当前菜单显示，如果是页面则是上一级（菜单）显示
      if (item) {
        if (item.openType == '1') {// 1-内部打开url（一般指嵌入）
          return item.path;
        }
        if (item.openType == '2') {// 2-外部打开路由（大屏设计等，根据Layout选择可以包含侧边栏等场景）
          return item.parentPath;
        }
        if (item.openType == '3') {// 3-外部打开url（指在菜单跳转到外部，eg：swagger地址）
          return item.path;
        }
        return item.parentPath;// 0-内部打开路由（默认）
      }
      return null;
    },
    /**
     * 查找菜单路由的子页面路由（redirect路由的页面）
     */
    findMenuSubRoute(menuRoute) {
      let subList = menuRoute.children || []
      let path = (menuRoute.parentPath ? menuRoute.parentPath : '') + '/' + menuRoute.redirect
      return subList.find(item => item.path === path)
    },

    /**
     * 菜单选择事件
     *
     * @param index /sys/workdate
     * @param indexPath  ["8", "/sys/workdate"]
     * @param elMenuItem VueComponent(el-menu-item)
     */
    handleSelect(index, indexPath, elMenuItem) {
      let menuRoute = elMenuItem.route;
      let path = index; // TODO linkType
      console.log("----handleSelect---->", this.activeMenuPath, path, menuRoute)
      // 0-内部打开路由（默认）
      // 1-内部打开url（一般指嵌入）
      // 3-外部打开路由（大屏设计等，根据Layout选择可以包含侧边栏等场景）
      // 4-外部打开url（指在菜单跳转到外部，eg：swagger地址）
      if(menuRoute.openType == '0') {
        this.doInnerOpenLink(path, menuRoute);
      } else if(menuRoute.openType == '1') {
        this.doInnerOpenLink(path, menuRoute);
      } else if(menuRoute.openType == '2') {
        let routeData = this.$router.resolve({name: menuRoute.name, query: menuRoute.query});
        window.open(routeData.href, '_blank');
      } else if(menuRoute.openType == '3') {
        window.open(menuRoute.redirect, "_blank"); // _blank（默认）,_self,_parent,_top, framename
      } else {
        console.error("暂无此打开方式" + menuRoute.openType);
      }
    },

    // 内部打开外链/或者内开内（默认）
    doInnerOpenLink(path, menuRoute) {
      if (path === this.activeMenuPath) return;
      let route = this.findMenuSubRoute(menuRoute)
      if (route == null) {// 如果没有子路由，则使用当前路由，比如内链打开
        route = menuRoute;
      }
      this.$store.dispatch('doAddView', route).then((cachedViews) => {
        this.$router.push(menuRoute);
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/css/variables.less';

.menu-scroll-container  {
  :deep(.menu-container:not(.el-menu--collapse)) {
    width: 220px;
  }

  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  :deep(.el-menu) {
    border-right: 0;
  }

  .menu-container {
    :deep(.el-submenu__title:hover),
    :deep(.el-menu-item:hover),
    :deep(.el-menu-item.is-active) {
      background-color: @sidebarActiveBgColor !important;
    }
  }
}
</style>
